// import { UrlEncode } from "./u2gb.js";
import { $URL } from './gbk.js';
import jsonp from './jsonpRequest';
import { cloneDeep } from 'lodash';
import { uuid } from '@packages/common/utils';
import { mapState } from 'vuex';
let resultDataV2 = [];
export var dataAnalysis = {
    data() {
        return {
            searchResult: [],
            tableData: [],
            loading: false,
            loadingText: '正在加载数据',
            pageRange: null, // 单选页码范围(会随着查询而变化)
            tempPageRange: null, // 单选页码范围(不变的)
            shopUrl: '', // 店铺地址 全店产品排名查询
            offerId: null, // 产品 Id 单产品排名查询
            isKeywordQuery: false, // 关键词排名查询
            keyWordHasAjax: false, // 关键词排名查询只需要执行一次
            keywords: '', // 输入框中的关键词
            keyword: '', // 输入框中的某个关键词
            resultData: '', // jsonp返回的html
            callBack: null,
            // offerInfo: {},
            query: {
                index: 1,
                size: 10,
                total: 0,
            },
            isShowBtn: false,
            isShowList: true,
            blocked: 0, // 被屏蔽次数 0:前端请求,1:后端请求,2:请求失败（被屏蔽）
            usedNum: 0, // 使用个数
            totalNum: 100, // 最多查几个关键词
            requestNum: 0, // 前端请求几个关键词
            taskId: '',
        };
    },
    computed: {
        ...mapState({ memberInfo: (state) => state.info.memberInfo }),
    },
    mounted() {
        this.$ajax
            .post('app/ca/isshowbutton', {
                buttonType: 1,
            })
            .then((data) => {
                if (data.Code == 200) {
                    this.isShowBtn = data.Result;
                }
            });
        this.callBack = (data) => {
            this.$refs.rankList.searchFail = true;
            if (this.isKeywordQuery) {
                // 关键词排名查询
                this.searchResult = [...this.searchResult, ...data.result];
                this.query.total = this.searchResult.length;
                if (JSON.stringify(data.offerInfo) != '{}' && this.tableData.length === 0) {
                    this.isShowList = true;
                    this.handleData(0, this.query.size, data.offerInfo);
                }
            } else if (JSON.stringify(data.offerInfo) != '{}') {
                // Object.assign(this.offerInfo, data.offerInfo)
                this.isShowList = true;
                this.searchResult = data.result;
                this.handleData(0, data.result.length, data.offerInfo);
            }
            if (data.isComplete) {
                this.$ajax
                    .post('app/ca/savekw', {
                        keyword: this.keyword,
                    })
                    .then(() => {});
                if (this.blocked === 0) {
                    this.requestNum++;
                }
                if (this.keywords.length) {
                    this.startTask();
                } else {
                    this.isShowList = true;

                    if (this.blocked === 0) {
                        this.modifyRequestNum();
                    } else if (this.blocked === 1) {
                        this.getKeywordNum();
                    }
                }
            }
        };
        this.getKeywordNum();
    },
    methods: {
        pageChange(index, mobile = false) {
            // 翻页
            this.query.index = index;
            const { size } = this.query;
            const start = (index - 1) * size;
            let end = index * size;
            end = Math.min(end, this.searchResult.length); // 取最小值 end是理想状态数量满的情况，但是可能存在1页搜索到的不满60条
            const ids = [];
            for (let i = start; i < end; i++) {
                ids.push(this.searchResult[i].offerId);
            }
            if (!mobile) {
                this.loadingText = '正在加载数据';
            }
            this.loading = true;
            this.$ajax
                .post('app/so/getoffers', {
                    offerIds: ids,
                })
                .then((res) => {
                    if (!res) {
                        this.loading = false;
                        this.tableData = [];
                        return;
                    }
                    if (this.port === 1) {
                        // 移动端
                        this.handleMobileData(start, end, res);
                        if (mobile) {
                            this.getKeywordNum();
                        }
                        return;
                    }
                    this.handleData(start, end, res);
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
        handleData(start, end, data) {
            const list = [];
            for (let i = start; i < end; i++) {
                const item = this.searchResult[i];
                if (!item) {
                    continue;
                }
                const production = cloneDeep(data[item.offerId]);
                if (!production || !production.ProductInfo) {
                    continue;
                }
                production.keyword = item.keyword;
                production.shilitag = item.shilitag;
                production.companyTag = item.companyTag;
                production.tradeBt = item.tradeBt;
                production.type = item.type;
                production.pageIndex = item.pageIndex;
                production.rank = item.rank;
                production.detailUrl = item.detail;
                production.title = production.ProductInfo.Subject.replace(
                    item.keyword,
                    '<font style="color: red;">' + item.keyword + '</font>'
                );
                list.push(production);
            }
            if (this.isKeywordQuery) {
                // 关键词排名查询
                this.tableData = list;
            } else {
                this.tableData = [...this.tableData, ...list];
            }
        },
        getPageRange(val) {
            // 页码单选框选中处理
            if (this.port !== val.port) {
                this.$refs.rankList.searchFail = false;
                this.tableData = [];
                this.port = val.port;
            }
            // if (val.port === 0) {
            //   // pc端
            // } else {
            //   // 移动端
            // }
            const range = val.pages.split('-').map((v) => Number(v));
            this.tempPageRange = cloneDeep(range);
            if (this.$refs.rankList) {
                this.$refs.rankList.pageRange = cloneDeep(range); // 用于关键词未搜索到的提示
            }
            if (this.$refs.rankListV2) {
                this.$refs.rankListV2.pageRange = cloneDeep(range);
            }
        },
        async beginStart(keywords) {
            // 总起点
            this.keywords = keywords;
            await this.getKeywordNum();
            const restNum = this.totalNum - this.usedNum;
            const len = keywords.length;
            if (restNum === 0) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>0</em> 个，请明天再来查询`,
                    type: 'warning',
                });
                return;
            } else if (len > restNum) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>${restNum}</em> 个，请减少本次关键词查询个数`,
                    type: 'warning',
                });
                return;
            }
            this.resetData();
            this.createTaskId(); // 生成任务ID
            this.blocked = this.requestNum = 0;
            this.isShowList = false;
            this.$refs.rankList.port = this.port;
            if (this.port === 1) {
                // 移动端
                this.showPagination = true;
                this.loading = true;
                this.mobileStart();
            } else {
                // PC端
                this.startTask();
            }
        },

        createTaskId() {
            let ajaxData = {
                keyWords: this.keywords,
                queryType: this.shopName ? 1 : this.offerId ? 2 : 3,
                queryPage: this.queryPage + 1,
            };
            if (this.getShopInfo && this.getShopInfo.CompanyName) {
                ajaxData.shopName = this.getShopInfo.CompanyName;
            }
            if (this.offerId) {
                ajaxData.queryLink = this.proLink;
            }

            this.$ajax.post('fw/api/v1/RankedQuery/Save', ajaxData).then((res) => {
                let { code, msg, result } = res;
                if (code !== 200) {
                    return this.$message.warning(msg);
                }
                this.taskId = result.taskId; // 先获取任务ID
            });
        },

        startTask() {
            // 每个关键词搜索的起点
            const keyword = (this.keyword = this.keywords.splice(0, 1)[0]); // 获取数组第一个关键词
            const encode = $URL.encode(keyword.replace(' ', '+'));
            this.loading = true;
            this.resultData = '';
            this.pageRange = cloneDeep(this.tempPageRange);

            // 直接请求后端接口 -----------------------------------------
            this.blocked = 1;
            resultDataV2 = [];
            this.checkBlocked(keyword, this.pageRange[0], encode);
            // ---------------------------------------------------------

            // 先jsonp请求再请求后端接口 ---------------------------------
            // this.getSearchData(keyword, 1, encode);
            // ---------------------------------------------------------
        },
        getSearchData(keyword, index, encode) {
            // index 循环次数，1次搜索20条结果，1页60条
            if (index > 3) {
                this.dataAnalysis(keyword, this.resultData, encode);
                this.resultData = '';
                return;
            }

            const url = `https://search.1688.com/service/marketOfferResultViewService?keywords=${encode}&n=y&netType=1%2C11%2C16&beginPage=${
                this.pageRange[0]
            }&async=true&asyncCount=20&pageSize=60&startIndex=${
                (index - 1) * 20
            }&pageName=major&requestId=BXAc6WFerx7ZnmskNnzEJTNtSBrzZk5TcQymhHYjjbk4fr7D`;
            this.loadingText = `正在排名查询 ${keyword} ${this.pageRange[0]}/${this.pageRange[1]}(页),请耐心等待...`;
            jsonp(url, { timeout: 10000 }, (err, res) => {
                // jsonp 请求
                if (err?.message == 'Timeout') {
                    this.blocked = 1;
                    this.checkBlocked(keyword, index, encode);
                    return;
                }
                if (res.rgv587_flag != undefined) {
                    this.blocked = 1;
                    this.checkBlocked(keyword, index, encode);
                } else {
                    this.resultData += res.content.offerResult.html;
                    this.getSearchData(keyword, index + 1, encode);
                }
            });
        },
        dataAnalysis(keyword, resultData, encode, uuid) {
            // 分析 jsonp 返回的 html 代码
            const div = document.createElement('div');
            div.innerHTML = resultData;
            const list = div.children;
            const pageIndex = this.pageRange[0];
            const arr = [];
            const shopUrl = this.shopUrl; // 店铺地址
            const offerId = this.offerId; // 产品 id
            const len = list.length;
            for (let i = 0; i < len; i++) {
                const itemLi = list[i]; // li 标签
                if (itemLi.outerHTML.indexOf('<li') == -1) {
                    continue;
                }
                let find = false; // 标志位
                const id = itemLi.getAttribute('t-offer-id');
                if (shopUrl) {
                    // 全店产品排名查询
                    const url1 = itemLi
                        .querySelector('.s-widget-offershopwindowcompanyinfo a.sw-dpl-offer-companyName')
                        ?.getAttribute('href');
                    const url2 = itemLi.querySelector('.sw-ka-supplier')?.getAttribute('href');
                    if (url1 != undefined && url1.indexOf(shopUrl) != -1) {
                        find = true;
                    }
                    if (url2 != undefined && url2.indexOf(shopUrl) != -1) {
                        find = true;
                    }
                } else if (offerId) {
                    // 单产品排名查询
                    find = offerId == id;
                } else {
                    // 关键词排名查询
                    this.isKeywordQuery = true;
                    find = true;
                }
                if (!find) {
                    continue;
                }
                const tradeBt = itemLi.querySelector('.sm-offer-tradeBt em')?.innerText?.trim() ?? '';
                const type =
                    itemLi
                        .querySelector('div.imgofferresult-mainBlock div.sm-offer-title div.wsw-ball a')
                        ?.innerText?.trim() ?? '';
                const row = {
                    offerId: id,
                    memberId: itemLi.getAttribute('t-member-id'),
                    companyTag: itemLi.querySelector('.sw-ui-flaticon-cxt16x16')?.innerText ?? '', // 诚信通
                    tradeBt: tradeBt.length === 0 ? '-' : tradeBt + '元', // 30天成交量
                    shilitag: itemLi.querySelectorAll('.sm-offer-shilitag').length !== 0, // 实力商家
                    rank: itemLi.getAttribute('t-rank'), // 第1条
                    type: type === '广告' ? '网销宝' : '自然搜索', // 类型
                    pageIndex,
                    keyword,
                    detail: `https://s.1688.com/selloffer/offer_search.htm?keywords=${encode}&beginPage=${pageIndex}`, // 点击查看
                };
                arr.push(row);
                if (offerId) {
                    break;
                } // 产品模式只匹配一次
            }
            if (pageIndex >= this.pageRange[1] || len < 60 || (offerId && arr.length !== 0)) {
                this.getOfferInfo(arr, true);
            } else {
                this.getOfferInfo(arr, false, () => {
                    this.pageRange[0] = pageIndex + 1;
                    if (this.blocked === 0) {
                        this.getSearchData(keyword, 1, encode);
                    } else if (this.blocked === 1) {
                        this.anotherRequest(keyword, 1, encode, uuid);
                    }
                });
            }
        },
        getOfferInfo(arr, isComplete, callBack) {
            if (arr.length) {
                let maxLength;
                if (this.isKeywordQuery) {
                    // 关键词排名查询
                    if (this.keyWordHasAjax) {
                        // 关键词排名查询只需要执行一次
                        if (isComplete) {
                            this.loading = false;
                        }
                        this.callBack &&
                            this.callBack({
                                offerInfo: {},
                                result: arr,
                                keyword: this.keyword,
                                isComplete,
                            });
                        callBack && callBack();
                        return;
                    } else {
                        maxLength = 10; // 展示10条数据
                    }
                }
                const offerIds = [];
                for (let i = 0, len = arr.length; i < len; i++) {
                    if (arr[i] && arr[i].offerId) {
                        offerIds.push(arr[i].offerId);
                    }
                    if (maxLength && maxLength === offerIds.length) {
                        break;
                    }
                }
                this.$ajax
                    .post('app/so/getoffers', {
                        offerIds,
                    })
                    .then((res) => {
                        if (isComplete) {
                            this.loading = false;
                        }
                        this.keyWordHasAjax = true;
                        this.callBack &&
                            this.callBack({
                                offerInfo: res || {},
                                result: arr,
                                keyword: this.keyword,
                                isComplete,
                            });
                        callBack && callBack();
                    });
            } else {
                if (isComplete) {
                    this.loading = false;
                }
                this.callBack &&
                    this.callBack({
                        offerInfo: {},
                        result: arr,
                        keyword: this.keyword,
                        isComplete,
                    });
                callBack && callBack();
            }
        },
        resetData() {
            this.searchResult = [];
            this.tableData = [];
            this.keyWordHasAjax = false;
            this.searchData = [];
            // this.offerInfo = {};
            this.resultData = '';
            resultDataV2 = [];
            this.query = {
                index: 1,
                size: 10,
                total: 0,
            };
        },
        checkBlocked(keyword, index, encode) {
            if (this.blocked === 1) {
                // 前端请求
                const id = uuid();
                this.anotherRequestV2(keyword, index, encode, id);
            } else if (this.blocked === 2) {
                // 前端+后端请求都失败了
                if (this.resultData !== '') {
                    this.dataAnalysis(keyword, this.resultData, encode);
                    this.resultData = '';
                    return;
                }
                this.loading = false;
                this.isShowList = true;
                const tips =
                    '相同IP下搜索过于频繁，被阿里限制了，搜索结果无法返回。建议您登录1688后再进行搜索，<a href="https://login.1688.com/member/signin.htm?tracelog=member_signout_signin" target="_blank" style="color:red">请登录</a><br />如果已登录，建议您晚点再尝试。';
                this.$alert(tips, '消息', {
                    dangerouslyUseHTMLString: true,
                    showConfirmButton: false,
                    showCancelButton: false,
                    callback: () => {},
                });
            }
        },
        anotherRequest(keyword, index, encode, id) {
            if (index > 3) {
                this.dataAnalysis(keyword, this.resultData, encode, id);
                this.resultData = '';
                return;
            }
            this.loadingText = `正在排名查询 ${keyword} ${this.pageRange[0]}/${this.pageRange[1]}(页),请耐心等待...`;
            this.$ajax
                .post('app/api/ca/AnalysisKeyWord', {
                    taskId: id,
                    keyword,
                    startIndex: (index - 1) * 20,
                    beginIndex: this.pageRange[0],
                })
                .then((res) => {
                    if (res.code === 200) {
                        let data;
                        try {
                            data = eval(JSON.parse(res.result));
                        } catch {
                            // do nothing
                        } finally {
                            if (!data) {
                                data.content.offerResult.html = '';
                            }
                            if (data.rgv587_flag != undefined) {
                                this.blocked = 2;
                                this.checkBlocked(keyword, index, encode);
                            } else {
                                this.resultData += data.content.offerResult.html;
                                this.anotherRequest(keyword, index + 1, encode, id);
                            }
                        }
                    } else {
                        this.$message.warning(res.msg);
                        if (this.resultData !== '') {
                            this.dataAnalysis(keyword, this.resultData, encode, id);
                            this.resultData = '';
                            return;
                        }
                        this.loading = false;
                        this.isShowList = true;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        anotherRequestV2(keyword, index, encode, id) {
            if (index > this.pageRange[1]) {
                this.dataAnalysisV2();
                resultDataV2 = [];
                return;
            }
            this.loadingText = `正在排名查询 ${keyword} ${index}/${this.pageRange[1]}(页),请耐心等待...`;
            this.$ajax
                .post('app/api/ca/analysiskeywordv2', {
                    taskId: id,
                    keyword,
                    beginIndex: index,
                })
                .then((res) => {
                    if (res.code === 200) {
                        const list = res.result?.list ?? [];
                        const arr = list.map((o, i) => {
                            return {
                                pageIndex: index,
                                offerId: o.offerId,
                                memberId: o.memberId,
                                companyTag: o.tpYear + '年', // 诚信通
                                tradeBt: o.quantitySumMonth + '件', // 30天成交量
                                shilitag: o.shiLiType === 'supermall', // 实力商家
                                rank: i + 1,
                                type: o.adGroupId ? '网销宝' : '自然搜索',
                                keyword,
                                detail: `https://s.1688.com/selloffer/offer_search.htm?keywords=${encode}&beginPage=${index}`, // 点击查看
                                loginId: o.loginId,
                            };
                        });
                        resultDataV2 = [...resultDataV2, ...arr];
                        this.anotherRequestV2(keyword, index + 1, encode, id);
                    } else {
                        throw res.msg;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    // 接口可能超时
                    this.dataAnalysisV2();
                });
        },
        dataAnalysisV2() {
            const shopUrl = this.shopUrl; // 店铺地址
            const offerId = this.offerId; // 产品 id
            let arr;
            if (shopUrl) {
                // 全店产品排名查询;
                const WangWang = this.getShopInfo.WangWang;
                arr = resultDataV2.filter((v) => v.loginId == WangWang);
            } else if (offerId) {
                // 单产品排名查询
                arr = resultDataV2.filter((v) => v.offerId == offerId);
            } else {
                // 关键词排名查询
                this.isKeywordQuery = true;
                arr = resultDataV2;
            }
            this.getOfferInfo(arr, true);
        },
        async getKeywordNum() {
            this.loading = true;
            await this.$ajax.post('app/api/ca/GetAnalysisSetting', {}).then((res) => {
                this.loading = false;
                if (res.code !== 200) {
                    this.$message.warning(res.msg);
                } else {
                    this.usedNum = res.result.competingAnalysisCount > 100 ? 100 : res.result.competingAnalysisCount;
                    this.totalNum = res.result.competingAnalysisLimit;
                }
            });
        },
        modifyRequestNum() {
            const num = this.requestNum;
            if (num === 0) {
                return;
            }
            this.$ajax
                .post('app/api/ca/ModifyAnalysisSetting', {
                    increment: num,
                })
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message.warning(res.msg);
                    } else {
                        this.usedNum += num;
                    }
                });
        },
        mobileStart() {
            // 移动端
            if (this.keywords.length) {
                const keyword = (this.keyword = this.keywords.splice(0, 1)[0]); // 获取数组第一个关键词
                this.loadingText = `正在排名查询 ${keyword},请耐心等待...`;
                this.searchMobileKeyword(keyword, this.tempPageRange[0], this.tempPageRange[1]);
            } else if (this.searchResult.length) {
                this.pageChange(1, true);
            } else {
                this.loading = false;
                this.isShowList = true;
                this.$refs.rankList.searchFail = true;
                this.getKeywordNum();
            }
        },
        // eslint-disable-next-line max-lines-per-function
        async searchMobileKeyword(keyword, analysisRangeStart, analysisRangeEnd) {
            let pages = Math.ceil(analysisRangeEnd / 40);
            let arr = [];
            const shopName = this.shopName; // 店铺地址
            const offerId = this.offerId; // 产品 id
            for (let i = 1; i <= pages; i++) {
                let res = await this.$ajax.post('app/api/ca/AnalysisKeyWordMobileV2', {
                    keyword,
                    BeginIndex: i,
                });
                if (res.code !== 200) {
                    this.$message.warning(res.msg);
                    this.keywords.length = 0; // 强制结束
                    break;
                }
                if (shopName) {
                    // 全店产品排名查询
                    const WangWang = this.getShopInfo.WangWang;
                    arr = [
                        ...arr,
                        ...res.result.filter((v) => {
                            if (v.loginId === WangWang) {
                                v.keyword = keyword;
                                return true;
                            }
                            return false;
                        }),
                    ];
                } else if (offerId) {
                    // 单产品排名查询
                    arr = [
                        ...arr,
                        ...res.result.filter((v) => {
                            if (v.offerId === offerId) {
                                v.keyword = keyword;
                                return true;
                            }
                            return false;
                        }),
                    ];
                } else {
                    // 关键词排名查询
                    arr = [
                        ...arr,
                        ...res.result.map((v) => {
                            return {
                                ...v,
                                keyword,
                            };
                        }),
                    ];
                }
            }
            if (arr.length) {
                this.$ajax.post('fw/api/v1/RankedQuery/SaveRankedQueryDetails', {
                    keyWord: keyword,
                    data: arr,
                    taskId: this.taskId,
                });
            }
            this.searchResult = [...this.searchResult, ...arr];
            this.mobileStart();
            ///api/ca/AnalysisKeyWordMobileV2
            // this.$ajax
            //     .post('app/api/ca/AnalysisKeyWordMobile', {
            //         keyword,
            //         analysisRangeStart,
            //         analysisRangeEnd,
            //     })
            //     .then((res) => {
            //         if (res.code !== 200) {
            //             this.$message.warning(res.msg);
            //             this.keywords.length = 0; // 强制结束
            //         } else {
            //             let arr = [];
            //             const shopName = this.shopName; // 店铺地址
            //             const offerId = this.offerId; // 产品 id
            //             // 筛选显示的产品
            //             if (shopName) {
            //                 // 全店产品排名查询
            //                 const WangWang = this.getShopInfo.WangWang;
            //                 arr = res.result.filter((v) => {
            //                     if (v.loginId === WangWang) {
            //                         v.keyword = keyword;
            //                         return true;
            //                     }
            //                     return false;
            //                 });
            //             } else if (offerId) {
            //                 // 单产品排名查询
            //                 arr = res.result.filter((v) => {
            //                     if (v.offerId === offerId) {
            //                         v.keyword = keyword;
            //                         return true;
            //                     }
            //                     return false;
            //                 });
            //             } else {
            //                 // 关键词排名查询
            //                 arr = res.result.map((v) => {
            //                     return {
            //                         ...v,
            //                         keyword,
            //                     };
            //                 });
            //             }
            //             this.searchResult = [...this.searchResult, ...arr];
            //         }
            //         this.mobileStart();
            //     })
            //     .catch(() => {
            //         this.loading = false;
            //     });
        },
        handleMobileData(start, end, res) {
            const arr = [];
            for (let i = start; i < end; i++) {
                const item = this.searchResult[i];
                const production = res[item.offerId];
                if (!production || !production.ProductInfo) {
                    // production.ProductInfo 有为 null 的情况
                    continue;
                }
                arr.push({
                    keyword: item.keyword, // 关键词
                    ProductInfo: {
                        ProductId: production.ProductInfo?.ProductId,
                        Image: production.ProductInfo?.Image,
                        QualityLevel: production.ProductInfo?.QualityLevel, // 星级
                    },
                    title: item.title.replace(item.keyword, '<font style="color: red;">' + item.keyword + '</font>'), // 产品标题
                    LastUpdateTime: production?.LastUpdateTime, // 更新时间
                    shilitag: item.power, // 实力商家
                    companyTag: item.tpYearNum + '年', // 诚信通年限
                    tradeBt: item.gmvPrice30d ? item.gmvPrice30d : '-', // 30天成交额
                    type: item.isP4P ? '网销宝' : '自然搜索',
                    pageIndex: item.order, // 第几个
                });
            }
            this.isShowList = true;
            this.loading = false;
            this.query.total = this.searchResult.length;
            this.tableData = arr;
        },
    },
};
